import React from "react";

const HeaderRow = ({ children }: { children?: React.ReactNode }) => {
  return <div className="header-row">{children} </div>;
};

export default HeaderRow;
